import { tooltipData, tooltipHelp } from "../createTooltip.js";
import MapboxDraw from "@mapbox/mapbox-gl-draw";

const DrawLineStringMode = MapboxDraw.modes.draw_line_string;

const _onMouseMove = DrawLineStringMode.onMouseMove;

DrawLineStringMode.onMouseMove = function (state, e) {
  const result = _onMouseMove.apply(this, [state, e]);

  const feature = state.line.toGeoJSON();

  tooltipData([feature], "line_string");
  tooltipHelp([feature], "line_string");
  state.line.properties.sysType = "line_string";
  state.line.properties.sysData = tooltipData(
    [feature],
    "line_string",
    false,
    true
  );

  return result;
};

export default DrawLineStringMode;
